import React from "react";
import ReactDOM from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./App";
import { Provider } from 'react-redux';
import store from "./store";
// import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  rootElement
);



// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';

// import App from './App';


// const rootElement = document.getElementById("root");
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   rootElement
// );

// import React from "react";
// import ReactDOM from "react-dom";

// import Box from "./Box";


// const rootElement = document.getElementById("root");
// ReactDOM.render(
//   <React.StrictMode>
//     {/* <App /> */}
//     <Box
//       name="Raphael"
//       image="https://img.icons8.com/ios-filled/50/000000/maxcdn.png"
//     />
//     <Box name="Elen" />
//     <Box name="Alex" />
//   </React.StrictMode>,
//   rootElement
// );


